import DOMPurify from "dompurify";
import { Marked } from "marked";

// Own Marked instance so options set here never leak into the global `marked` singleton other code
// might rely on. `breaks: true` makes a single newline render as a line break, preserving the plain
// `whitespace-pre-line` feel the app long description had before it became Markdown.
const markdown = new Marked({
  gfm: true,
  breaks: true,
});

/**
 * Render user-authored Markdown to XSS-safe HTML.
 *
 * marked turns the source into HTML; DOMPurify then strips everything that isn't safe display markup
 * (`<script>`, `on*` handlers, `javascript:` URLs, iframes, …), so the result is safe to bind with
 * `v-html`. Reused by {@link VMarkdown} and available on its own for non-component call sites.
 */
export function renderMarkdown(source: string | null | undefined): string {
  if (!source) {
    return "";
  }

  const rawHtml = markdown.parse(source, { async: false });

  return DOMPurify.sanitize(rawHtml, {
    USE_PROFILES: { html: true },
  });
}
